import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useTranslation } from 'react-i18next';

const OmnichannelChatWarningDialog = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningAmberIcon sx={{ color: 'warning.main' }} />
          <Typography variant="h6">
            {t('calculator.omnichannelChatWarning.title', 'Product Requirements')}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('calculator.omnichannelChatWarning', 'Omnichannel Chat requires Business Phone to be added first.')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button 
          onClick={onClose} 
          color="primary" 
          variant="contained"
          sx={{
            minWidth: 120,
            minHeight: 44,
            fontSize: '1rem',
            fontWeight: 500
          }}
        >
          {t('common.ok', 'OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OmnichannelChatWarningDialog;